export default __webpack_public_path__ + "static/media/Katheryne.00826a63.png";